// Add your custom JS here.

// Sticky header: toggle `is-sticky` class when scrolling
(function () {
	function initStickyHeader() {
		var header = document.querySelector('header.site-header, header#masthead, .site-header, .navbar');
		if (!header) return;

		var lastKnownScrollY = 0;
		var ticking = false;

		function onScroll() {
			lastKnownScrollY = window.pageYOffset || document.documentElement.scrollTop;
			if (!ticking) {
				window.requestAnimationFrame(function () {
					updateHeader(lastKnownScrollY);
					ticking = false;
				});
				ticking = true;
			}
		}

		function updateHeader(scrollY) {
			if (scrollY > 10) {
				header.classList.add('is-sticky');
			} else {
				header.classList.remove('is-sticky');
			}
		}

		// Init state
		updateHeader(window.pageYOffset || document.documentElement.scrollTop);
		window.addEventListener('scroll', onScroll, { passive: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initStickyHeader);
	} else {
		initStickyHeader();
	}
})();